<template>
  <div class="edit-table">
    <div class="padding_50">
      <vxe-table
        show-overflow=""
        ref="fineTable"
        :data="subjectList"
        min-height="100px"
        max-height="250px"
      >
        <vxe-table-column min-width="100" field="code" title="物料编码">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="name" title="物料名称">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="classifyName" title="物料分类">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="kind" title="具体品类">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="spec" title="规格型号">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="unitName" title="单位">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="num" title="数量">
          <template #default="{ row }">
            <el-input-number
              v-model="row.num"
              :precision="0"
              placeholder="数量"
              disabled
              :controls="false"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="100" field="price" title="单价">
          <template #default="{ row }">
            <el-input-number
              v-model="row.price"
              :precision="2"
              placeholder="单价"
              disabled
              :controls="false"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="100" field="totalPrice" title="总价">
          <template #default="{ row }">
            <el-input-number
              v-model="row.totalPrice"
              placeholder="总价"
              disabled
              :controls="false"
            ></el-input-number>
          </template>
        </vxe-table-column>

        <vxe-table-column
          min-width="100"
          field="preCloseNum"
          title="已关闭数量"
        >
          <template #default="{ row }">
            <el-input-number
              v-model="row.preCloseNum"
              placeholder="已关闭数量"
              disabled
              :controls="false"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          min-width="100"
          field="preCloseAmount"
          title="已关闭金额"
        >
          <template #default="{ row }">
            <el-input-number
              v-model="row.preCloseAmount"
              placeholder="已关闭金额"
              disabled
              :controls="false"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="100" field="curCloseNum" title="关闭数量">
          <template #default="{ row, rowIndex }">
            <el-input-number
              v-model="row.curCloseNum"
              placeholder="关闭数量"
              :disabled="closeAllFlag === '1' || disabled"
              :controls="false"
              :max="row.num - row.preCloseNum"
              @change="changeCloseNumber(row, rowIndex)"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          min-width="100"
          field="curCloseAmount"
          title="关闭金额"
        >
          <template #default="{ row }">
            <el-input-number
              v-model="row.curCloseAmount"
              placeholder="关闭金额"
              disabled
              :controls="false"
            ></el-input-number>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addForm',
  components: {},
  props: {
    value: Array,
    disabled: Boolean,
    materialClassifyList: Array,
    materialUnitList: Array,
    closeAllFlag: String,
  },
  watch: {
    value: {
      handler(val) {
        this.subjectList = val || [];
      },
      deep: true,
    },
    closeAllFlag: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val === '1') {
          this.subjectList.forEach((item) => {
            item.curCloseNum = item.num - item.preCloseNum;
            item.curCloseAmount = item.totalPrice - item.preCloseAmount;
          });
          let amount = 0;
          this.subjectList.forEach((i) => {
            amount = this.accAdd(amount, Number(i.curCloseAmount));
          });
          this.$emit('input', this.subjectList);
          this.$emit('addCloseTotal', amount || 0);
        }
      },
    },
  },
  data() {
    return {
      subjectList: [], // 当前关联费用科目数据
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 计算总价
    changeNumber(row, index) {
      console.log(row, index);
      const totalPrice = this.floatMul(row.num || 0, row.price || 0);
      this.subjectList[index].totalPrice = totalPrice;
      let amount = 0;
      this.subjectList.forEach((i) => {
        amount = this.accAdd(amount, Number(i.totalPrice));
      });
      this.$emit('input', this.subjectList);
      this.$emit('addTotal', amount || 0);
    },
    // 计算关闭总价
    changeCloseNumber(row, index) {
      const curCloseAmount = this.floatMul(
        row.curCloseNum || 0,
        row.price || 0,
      );
      this.subjectList[index].curCloseAmount = curCloseAmount;
      let amount = 0;
      this.subjectList.forEach((i) => {
        amount = this.accAdd(amount, Number(i.curCloseAmount));
      });
      this.$emit('input', this.subjectList);
      this.$emit('addCloseTotal', amount || 0);
    },
    // 乘
    floatMul(arg1 = 0, arg2 = 0) {
      let m = 0;
      const s1 = arg1.toString();
      const s2 = arg2.toString();
      // eslint-disable-next-line no-empty
      try {
        m += s1.split('.')[1].length;
      } catch (e) {
        // eslint-disable-next-line no-empty
      }
      // eslint-disable-next-line no-empty
      try {
        m += s2.split('.')[1].length;
      } catch (e) {
        // eslint-disable-next-line no-empty
      }
      // eslint-disable-next-line no-mixed-operators
      return (
        (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / 10 ** m
      );
    },
    // 两个浮点数求和
    accAdd(num1 = 0, num2 = 0) {
      let r1;
      let r2;
      let m = 0;
      try {
        r1 = num1.toString().split('.')[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = num2.toString().split('.')[1].length;
      } catch (e) {
        r2 = 0;
      }
      // eslint-disable-next-line no-restricted-properties
      m = Math.pow(10, Math.max(r1, r2));
      // return (num1*m+num2*m)/m;
      return Math.round(num1 * m + num2 * m) / m;
    },
  },
};
</script>

<style lang="less" scoped>
.padding_50 {
  padding-left: 20px;
}
.form_title {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-left: 0;
  margin-top: 14px;
  margin-bottom: 20px;
}
.edit-table {
  margin-left: 0 !important;
}
.cost-select {
  position: relative;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }
  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
</style>
